'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function ActionPanel() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.presenter = $('[data-mogo-ui=Portal]').mogo().presenter;

  this.contentId = null;
  this.contentSpace = null;
  this.rewardPanel = null;
  this.contentName = null;

  this._contentModelRef = null;

  this.init = function () {
    if (this.rewardPanel && !this.contentName) {
      console.error('ActionPanel.js: "contentName" is a required argument.');
      this.node.style.display = 'none';
      return false;
    }

    // 'id' needed in case content id starts with a number
    this._contentModelRef = 'content.id_' + this.contentId;

    if (this.presenter.getModelProperty(this._contentModelRef)) {
      this._populateContent();
    } else {
      this._loadContent();
    }
  };

  this._loadContent = function () {
    var _this = this;

    this._contentful = new Contentful(_ContentfulConfiguration, $.extend({}, this._getContentfulSpaceParams(), { verboseLevel: 1 }));

    this._contentful.getResource('ENTRY', { entry_id: this.contentId }, function (data) {
      _this._storeContent(data);
      _this._populateContent();
    });
  };

  this._storeContent = function (data) {
    if (!this.presenter.models.content) {
      this.presenter.createModel('content', {
        data: {}
      });
    }
    this.presenter.setModelProperty(this._contentModelRef, data.items[0]);
  };

  this._populateContent = function () {
    var _this2 = this;

    // use Product class to do heavy lifting on content insertion
    // assumes specific HTML structure and content field names
    // TODO: make lower-level class that both Product and ActionPanel can use
    // DEPRICATION OF PROODUCT.JS IN FAVOUR OF CONTENTFULDOMHELPER.JS IN PROGRESS
    this._product = new Product(this._contentModelRef, this.presenter);
    this._contentfulDOMHelper = new ContentfulDOMHelper(this._contentModelRef, this.presenter);

    // content references without a specific attribute either insert descendant
    // HTML or populate existing HTML based on the type of content retrieved
    var nodeList = [].concat(_toConsumableArray(this.node.querySelectorAll('[data-content-ref]')));
    nodeList.forEach(function (node) {
      var contentRef = node.dataset.contentRef;
      var preserveAspectRatio = node.dataset.preserveAspectRatio;

      var contentObject = _this2.presenter.getModelProperty(_this2._contentModelRef + '.' + contentRef);
      var panelLinkRef = _this2.presenter.getModelProperty('' + _this2._contentModelRef);

      if (contentRef === 'panelLink') {
        _this2._contentfulDOMHelper.bindLinkToElement(node, 'nav-action-1', panelLinkRef);
      }

      // for string content, assume HTML content to be inserted as descendant
      if (typeof contentObject === 'string') {
        _this2._product.loadHTML(node, contentRef);

        // for content that is a reference to an object (embedded content item)
      } else if ((typeof contentObject === 'undefined' ? 'undefined' : _typeof(contentObject)) === 'object') {
        var contentfulConfig = {};

        // Product assumes particular field names for specific content types
        if (contentObject._type === 'Asset' && contentRef.toLowerCase().includes('media')) {
          if (preserveAspectRatio) contentfulConfig.preserveAspectRatio = preserveAspectRatio;
          _this2._contentfulDOMHelper.loadMedia(node, contentfulConfig, contentRef);
        } else if (contentObject._contentType && contentObject._contentType.sys && contentObject._contentType.sys.id) {
          if (contentObject._contentType.sys.id === 'button' && contentRef.toLowerCase().includes('cta')) {
            _this2._product.loadPrimaryCta(node, 'nav-action-1', null, { primaryCta: contentObject });
          }
        }
      }
    });

    // attribute values from external content values
    var attributesList = ['src', 'href'];
    attributesList.forEach(function (attributeName) {
      var attributeUpdateNodes = [].concat(_toConsumableArray(_this2.node.querySelectorAll('[data-content-attr-' + attributeName + ']')));
      attributeUpdateNodes.forEach(function (node) {
        var contentRef = node.dataset['contentAttr' + _this2._capitalizeFirstLetter(attributeName)];
        var contentObject = _this2.presenter.getModelProperty(_this2._contentModelRef + '.' + contentRef);

        // content must be a string
        if (typeof contentObject === 'string') {
          node.setAttribute(attributeName, contentObject);
        }
      });
    });

    $(this.node).show();
  };

  this._capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  this._getContentfulSpaceParams = function () {
    return this.contentSpace === 'App' ? ContentfulAppSpaceParams : ContentfulSpaceParams;
  };

  this.initAllReady = function () {};

  this.destroy = function () {};
}